module.exports = __webpack_public_path__ + "media/newstyle/images/logo-amazon-6a2809890be96d020dbf0465bae3f7e3.png";